export default __webpack_public_path__ + "static/logo_top-a178dd250a9af69d32882c54636c4f91.png";